import { DEFAULT_FIVERR_LANGUAGE } from '../supportedFiverrLocales';
import { getShortLanguageCode } from '../shortLanguageCode';
import { isSupportedSellerLanguage } from '../supportedSellerLanguages';
import { COUNTRIES_TO_LANGUAGE_MAP } from './constants';

/**
 * Assuming the buyer language according to the context of the request.
 * Current logic (prioritized):
 * - If it has specific locale (other than English) -
 *      return it as the buyer assumed language.
 * - If the browser language is other than English -
 *      return browser language as the buyer assumed language.
 * - If the buyer is from a specific supported mapped country -
 *      we map him to a specific language according to COUNTRIES_TO_LANGUAGE_MAP
 * @param context {{ locale: String, browserLanguage: String, countryCode: String }} -
 *      The locale, country code and the browser language of the buyer,
 *      most probably from the context (either Fiver Context or Request Context)
 * @returns {string} - the buyer assumed language in format of language code ('en' / 'nl' etc)
 */
export const getBuyerAssumedLanguage = ({ locale, browserLanguage, countryCode }) => {
    let buyerAssumedLanguage = DEFAULT_FIVERR_LANGUAGE;
    const localeShort = locale && getShortLanguageCode(locale);
    if (localeShort !== buyerAssumedLanguage && isSupportedSellerLanguage(localeShort)) {
        buyerAssumedLanguage = localeShort;
    } else {
        const browserLanguageShort = browserLanguage && getShortLanguageCode(browserLanguage);
        if (browserLanguageShort !== buyerAssumedLanguage && isSupportedSellerLanguage(browserLanguageShort)) {
            buyerAssumedLanguage = browserLanguageShort;
        } else if (COUNTRIES_TO_LANGUAGE_MAP[countryCode]) {
            buyerAssumedLanguage = COUNTRIES_TO_LANGUAGE_MAP[countryCode];
        }
    }

    return buyerAssumedLanguage;
};
